import Api           from '@/helpers/Api.js';
import normalize     from 'json-api-normalizer';
import qs            from 'qs';
import jsonNormalize from '@lysyi3m/json-api-normalizer';

// Import mutations
import {
    SET_MESSAGES,
    RESET_MESSAGES_STATE
} from './mutation-types.js';

const resource  = '/connectors/sms/v1/messages';

// Initial state
const state = () => ({ messages: {} });

// Getters
const getters = {};

// Actions
const actions = {
    create: (context, { phoneNumber, content }) => {
        return new Promise((resolve, reject) => {
            Api.post(`${resource}?include=conversation`, {
                'data': {
                    'type':       'messages',
                    'attributes': {
                        'to': phoneNumber,
                        content
                    }
                }
            })
                .then(async (response) => {
                    const normalizedData = await context.dispatch('afterMessageCreation', response);
                    resolve(normalizedData);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    createMms: (context, { phoneNumber, content, media  }) => {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('to', phoneNumber);
            formData.append('content', content);
            media.forEach((item, index) => {
                formData.append(`media[${index}]`, item.file);
            });

            Api.post(`${resource}/mms-message?include=conversation,media`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then(async (response) => {
                    const normalizedData = await context.dispatch('afterMessageCreation', response);
                    resolve(normalizedData);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    /**
     * After SMS/MMS creation
     */
    afterMessageCreation (context, response) {
        const normalizedData = normalize(response.data, { camelizeKeys: false });
        const jsonNormalizedData = jsonNormalize(response.data, { camelizeKeys: false });

        // Detach the message from its parent, the back-reference makes the state cyclic
        const { conversation, ...message } = jsonNormalizedData.data;

        // Initialize the messages array if empty
        if (conversation.messages === undefined) {
            conversation.messages = [];
        }

        context.commit(
            'core/conversations/APPEND_SINGLE_CONTACT_CONVERSATIONS',
            { conversations: { [conversation.id]: conversation } },
            { root: true }
        );
        context.commit('core/conversations/APPEND_CURRENT_CONVERSATION_WITH_NEW_MESSAGE', {
            conversationId: conversation.id,
            data:           message
        }, { root: true });

        // The message may have started a new conversation, make it the active one so it can be terminated
        if (conversation['is-active']) {
            const activeConversation = context.rootState.core.conversations.contactActiveConversation;

            context.commit(
                'core/conversations/SET_SINGLE_CONTACT_ACTIVE_CONVERSATION',
                activeConversation?.id === conversation.id ?
                    { ...activeConversation, 'active-users': conversation['active-users'] } :
                    conversation,
                { root: true }
            );
        }

        return normalizedData;
    },

    /**
     * List SMS received to number
     *
     * @param   {Object}  context  The context
     * @param   {String}  phoneNumber active sms phone number
     *
     * @return  {Promise}
     */
    index: (context, payload) => {
        const urlParams = {};
        if (payload) {
            urlParams.sort    = payload.sort ? payload.sort : void 0;
            urlParams.filter  = payload.filters ? payload.filters : void 0;
            urlParams.include = payload.include ? payload.include : void 0;
        }

        return new Promise((resolve, reject) => {
            Api.get(`${resource}`, {
                params:           urlParams,
                paramsSerializer: params => qs.stringify(params, {
                    encode: false
                })
            })
                .then(response => {
                    const normalizedData = normalize(response.data, { camelizeKeys: false });
                    const jsonNormalizedData = jsonNormalize(response.data, { camelizeKeys: false });
                    context.commit(SET_MESSAGES, jsonNormalizedData.data);
                    resolve(normalizedData);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    /**
     * Reset state
     */
    resetMessagesState (context) {
        context.commit(RESET_MESSAGES_STATE);
    }
};

// Mutations
const mutations = {
    [SET_MESSAGES]: (state, payload) => {
        state.messages = payload;
    },
    [RESET_MESSAGES_STATE]: (state) => {
        state.messages = {};
    }
};

// Export module
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
